import React from "react";
import { ArrowUpRight } from "lucide-react";
import { HOPLINK, HOPLINK_TARGET, HOPLINK_REL } from "../lib/hoplink";

export const CTAButton = ({
    label = "Check Today's Offer",
    testId = "cta-check-offer",
    variant = "primary",
    className = "",
    style = undefined,
}) => {
    if (variant === "ghost") {
        return (
            <a
                data-testid={testId}
                href={HOPLINK}
                target={HOPLINK_TARGET}
                rel={HOPLINK_REL}
                className={`btn-ghost ${className}`}
                style={style}
            >
                {label}
                <ArrowUpRight size={16} strokeWidth={1.5} />
            </a>
        );
    }
    return (
        <a
            data-testid={testId}
            href={HOPLINK}
            target={HOPLINK_TARGET}
            rel={HOPLINK_REL}
            className={`btn-primary ${className}`}
            style={style}
        >
            {label}
            <ArrowUpRight size={16} strokeWidth={1.75} />
        </a>
    );
};
